import { SessionCacheService } from '@anecdotes/utils';
import { PagedGrid } from '../../../../models';
import { v4 as generateGuid } from 'uuid';

export class ChunksCache {
  private prefix = `grid-cache-${generateGuid()}-chunk-index`;

  constructor(private sessionCache: SessionCacheService) {}

  async writeAsync(chunkIndex: number, chunkRows: PagedGrid.GridChunkRow[]): Promise<void> {
    this.sessionCache.safeWriteAsync(`${this.prefix}-${chunkIndex}`, chunkRows);
  }

  async readAsync(chunkIndex: number): Promise<PagedGrid.GridChunkRow[]> {
    return this.sessionCache.safeReadAsync(`${this.prefix}-${chunkIndex}`);
  }

  async clearCacheIfExistsAsync(): Promise<void> {
    await this.sessionCache.deleteCacheEntriesByKeyPrefixAsync(this.prefix);
  }
}
